// src/pages/Wallet/components/ActionButtons.js
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { NetworkContext } from '../../../contexts/NetworkContext';
import { FaQrcode } from 'react-icons/fa';

const ActionButtons = ({ onSend, onReceive, onScanQR }) => {
  const { t } = useTranslation();
  const { currentChain } = useContext(NetworkContext);
  
  // Get native token symbol
  const nativeTokenSymbol = currentChain && currentChain.nativeTokenName
    ? currentChain.nativeTokenName.includes('(')
      ? currentChain.nativeTokenName.split('(')[1].replace(')', '').trim()
      : currentChain.nativeTokenName
    : 'ETH';
  
  return (
    <div className="send-receive-row">
      <button 
        className="send-btn" 
        onClick={() => onSend({ type: "native", symbol: nativeTokenSymbol })}
      >
        {t('wallet.send')}
      </button>
      <button 
        className="receive-btn" 
        onClick={onReceive}
      >
        {t('wallet.receive')}
      </button>
      <button 
        className="scan-btn" 
        onClick={onScanQR}
      >
        <FaQrcode className="scan-icon" /> {t('wallet.actions.scan')}
      </button>
    </div>
  );
};

export default ActionButtons;